import React, { useContext, useState, useEffect } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import CustomizerContext from '../../../_helper/Customizer';
import cartItem1 from '../../../assets/images/other-images/cart-img.jpg';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import { MarginBottom, MarginTop, pinagareAPIURL } from '../../../Constant';
import { Btn, P, Image, UL, LI, H6 } from '../../../AbstractElements';
import { FiAlignCenter } from "react-icons/fi";

export default function MoonLight() {
  const { addMixBackgroundLayout } = useContext(CustomizerContext);
  const [moonlight, setMoonlight] = useState(false);
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [omang, setOmang] = useState(localStorage.getItem("username"));
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {

    if(!isLoggedIn){
    
      const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'fetch_pinagare_roles',       
        
      });

      //pinagareFetchRequest(pinagareAPIURL,body_t);  
  
    }
    else{
            //console.log('err 99-----');
    }

  }, []);


  async function pinagareFetchRequest(url,body) {
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((respose) => {
          if (respose.ok) {
            //console.log('hh2 -- '+JSON.stringify(respose))
            return respose.json()
          }
          throw new Error('error')
        })
        .then((data) => {

          //console.log('gg23 -- '+JSON.stringify(data));

          if (data.status!=null) {

            setIsAdmin(data.admin); 
            setIsSuperAdmin(data.super_admin);
            setIsSupervisor(data.supervisor);   
            //localStorage.setItem('username', data.username);
            //localStorage.setItem("Name", data.name);

            //localStorage.removeItem('username_temp');
            //console.log('error other -- '+JSON.stringify(data));
            setIsLoggedIn(true);

            //toast.success("Roles fetch Successful...");

            //history(`${process.env.PUBLIC_URL}/dpsm/home`);

            //console.log('fetch success 1-----');

                          
          } else {
            //set error
            //console.log('error other -- '+JSON.stringify(data));
           // toast.error("OTP error occurred..");
            //setIsLoggedIn(false);
          }
        })
    } catch (error) {
      //console.log(JSON.stringify(error)+" --"); 
      //toast.error("Authentication failed.. "+JSON.stringify(error));
      //setIsLoggedIn(false);
    }
  }

  const [isMenuHoveringA, setIsMenuHoveringA] = useState(false);
  const [isMenuHoveringB, setIsMenuHoveringB] = useState(false);
  const [isMenuHoveringC, setIsMenuHoveringC] = useState(false);
  const [isMenuHoveringD, setIsMenuHoveringD] = useState(false);

  
  return (
   
    <li >
      <div className='md-sidebar' style={{width:"100%", margin:0,paddingBottom:0,paddingTop:0}}>

      <div style={{ width:"100%", position: "relative", top:12}}>
        <Btn attrBtn={{ onClick: (e) => setIsOpen(!isOpen), color: 'primary', className: 'md-sidebar-toggle' }} ><FiAlignCenter /></Btn></div>
        
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen && 'open'} `} style={{width:"100%", backgroundColor:"#ffffff", textAlign:"center", top:50, padding:8, border:isOpen ? "1px solid #e2e3e5" :"none",borderRadius:isOpen ? 8 : 0}}> 
     
	 

      <ol className='breadcrumb' style={{width:"100%", textAlign:"center", margin:0,paddingBottom:0, paddingTop:0,paddingLeft:5, paddingRight:5}} > 

                <li className='drts-menu-item' style={{ paddingRight:8, paddingLeft:8, paddingBottom:0, color:isMenuHoveringA ? '#6ec6ec' :"#000000" }} 
                 onMouseEnter={() => setIsMenuHoveringA(true)}
                 onMouseLeave={() => setIsMenuHoveringA(false)}
                >
                  <Link to={`${process.env.PUBLIC_URL}/eservices/home`}> 
                    <SvgIcon iconId='stroke-home' style={{ height: 20, width:20, color:isMenuHoveringA ? '#6ec6ec' :"#000000" }} />  
                  </Link>
                </li>
                <li className='drts-menu-item' style={{marginBottom: isOpen ? 13:2,paddingRight:35,paddingBottom:0}}
                 onMouseEnter={() => setIsMenuHoveringA(true)}
                 onMouseLeave={() => setIsMenuHoveringA(false)}
               >
                  <Link to={`${process.env.PUBLIC_URL}/eservices/home`}
                style={{color:isMenuHoveringA ? '#6ec6ec' :"#000000" }}>{ " Home"}</Link></li>

                <li className='drts-menu-item' style={{paddingRight:8,paddingBottom:0}}
                onMouseEnter={() => setIsMenuHoveringB(true)}
                onMouseLeave={() => setIsMenuHoveringB(false)}
                >  
                  <Link to={`${process.env.PUBLIC_URL}/eservices/about`}>   
                    <SvgIcon iconId='tag' style={{ height: 20, width:20 }} />   
                  </Link>
                </li>
                <li className='drts-menu-item' style={{marginBottom: isOpen ? 13:2,paddingRight:35,paddingBottom:0}}
                onMouseEnter={() => setIsMenuHoveringB(true)}
                onMouseLeave={() => setIsMenuHoveringB(false)}
                ><Link to={`${process.env.PUBLIC_URL}/eservices/about`}
                style={{color:isMenuHoveringB ? '#6ec6ec' :"#000000"}}>{ "About"}</Link></li>

                <li className='drts-menu-item' style={{paddingRight:8,paddingBottom:0}}
                onMouseEnter={() => setIsMenuHoveringC(true)}
                onMouseLeave={() => setIsMenuHoveringC(false)}
                >
                  <Link to={`${process.env.PUBLIC_URL}/eservices/help`}> 
                    <SvgIcon iconId='stroke-faq' style={{ height: 20, width:20 }} />
                  </Link>
                </li>
                <li className='drts-menu-item' style={{marginBottom: isOpen ? 13:2,paddingRight:35,paddingBottom:0}}
                onMouseEnter={() => setIsMenuHoveringC(true)}
                onMouseLeave={() => setIsMenuHoveringC(false)}
                ><Link to={`${process.env.PUBLIC_URL}/eservices/help`}
                style={{color:isMenuHoveringC ? '#6ec6ec' :"#000000"}}>{ "FAQs"}</Link></li>

                <li className='drts-menu-item' style={{paddingRight:8,paddingBottom:0}}
                onMouseEnter={() => setIsMenuHoveringD(true)}
                onMouseLeave={() => setIsMenuHoveringD(false)}
                >
                  <Link to={`${process.env.PUBLIC_URL}/eservices/contact`}>
                    <SvgIcon iconId='stroke-contact' style={{ height: 20, width:20 }} />
                  </Link>
                </li>
                <li className='drts-menu-item' style={{marginBottom: isOpen ? 13:2,paddingRight:5,paddingBottom:0}}
                onMouseEnter={() => setIsMenuHoveringD(true)}
                onMouseLeave={() => setIsMenuHoveringD(false)}
                ><Link to={`${process.env.PUBLIC_URL}/eservices/contact`}
                style={{color:isMenuHoveringD ? '#6ec6ec' :"#000000"}}>{ "Contact Us"}</Link></li>
                
        </ol>

        </div>

        {/*<Btn attrBtn={{ onClick: (e) => setIsOpen(!isOpen), color: 'primary', className: 'md-sidebar-toggle' }} >Pending Tasks Menu</Btn>
        
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen && 'open'} `} style={{top:50,paddingTop:0,backgroundColor:"#ffffff",borderRadius:8}}> 
        
        <Link to={`${process.env.PUBLIC_URL}/dpsm/system-admin`} className="btn" style={{ color:'#137aa7'	}}> 
          {"Home"}
        </Link>

        <Link to={`${process.env.PUBLIC_URL}/dpsm/system-admin`} className="btn" style={{ color:'#137aa7'	}}> 
        <span style={{paddingRight:'20px'}}>{""} </span>{"About"}
        </Link>

        <Link to={`${process.env.PUBLIC_URL}/dpsm/system-admin`} className="btn" style={{ color:'#137aa7'	}}> 
        <span style={{paddingRight:'20px'}}>{""} </span>{"Help"}
        </Link>

        <Link to={`${process.env.PUBLIC_URL}/dpsm/system-admin`} className="btn" style={{ color:'#137aa7'	}}> 
        <span style={{paddingRight:'20px'}}>{""} </span> {"Contact Us"}
        </Link>
	 

      </div>*/}
      </div>
    </li>
  );
};

//export default MoonLight;
